import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { z } from 'zod';
import { PageTitleContext } from '../../__root';
import { MediaAddForm } from '../../../features/media-units/components/media-add-form';
import { addToOfferIdSearchField } from '../../../lib/offer-context-search-schema';

/**
 * Offer-context param shared with the catalog route (`validateMediaUnitsSearch`)
 * and `/map`, forwarded from `/media-units`'s "Dodaj nośnik" button so creating
 * a new unit and returning to the catalog preserves "adding to offer X" context
 * instead of silently dropping it (CU-86caypxaw). See
 * offer-context-search-schema.ts for the full leniency rationale.
 */
const MediaAddFormSearchSchema = z
  .object({
    addToOfferId: addToOfferIdSearchField,
  })
  .strict();

export const Route = createFileRoute('/media-units/add/')({
  validateSearch: MediaAddFormSearchSchema,
  component: MediaAddFormPage,
});

export function MediaAddFormPage() {
  const { t } = useTranslation('inventory');
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { addToOfferId } = useSearch({ from: '/media-units/add/' });
  React.useEffect(() => {
    setPageTitle(t('form.add.pageTitle'));
  }, [setPageTitle, t]);
  return <MediaAddForm addToOfferId={addToOfferId} />;
}
